export default {
    organization: {
        name: "name",
        previewOptions: ["name", "id", "organizationType", "recipients"],
    },
    driver: {
        name: "name",
        previewOptions: ["name", "id", "email", "phoneNumber", "isOnline"],
    },
    truck: {
        name: "plateNumber",
        previewOptions: ["plateNumber", "id", "model", "truckTypeId", "supplierId"],
    },
    supplier: {
        name: "name",
        previewOptions: ["name", "id", "phoneNumber"],
    },
};
